<template>
  <div>
    <ft-navbar></ft-navbar>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">Deckenstäbe <span class="text-muted">({{filtered.length}}/{{products.length}})</span>
            </h2>
          </div>
          <div class="row">
            <div class="col-md-6">
              <ul>
                <li>Deckenstäbe werden in einem gewissen Abstand zur Wand an der Decke angebracht und werden zur
                  Raumgestaltung eingesetzt. Oft werden Deckenstäbe mit Eckgesimsen und Rosetten kombiniert.
                </li>
                <li>Deckenstäbe können wahlweise mit den passenden Eck- oder Mittelstücken ergänzt werden.</li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul>
                <li>Deckenstäbe können zum Einfassen von Bildern oder Wandspiegeln verwendet werden.</li>
                <li>Auf Wunsch werden auch Massanfertigungen hergestellt.</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row my-5">
          <b-form inline>
            <b-form-radio-group class="mb-2 mr-sm-4 mb-sm-1" id="btnradios1"
                                buttons
                                v-model="product"
                                :options="productViews"
            />
            <b-form-select :disabled="product !== 'b'" class="mb-2 mr-sm-4 mb-sm-1" v-model="width" :options="widths"/>
            <b-form-select :disabled="product !== 'b'" aria-label="Stile" class="mb-2 mr-sm-4 mb-sm-1" v-model="bStyle"
                           :options="bStyles"/>
            <b-form-input type="text" placeholder="Nummer (z.B. 1002)" v-model="mnumber"></b-form-input>
          </b-form>
        </div>
        <div class="row">
          <grid min="240px" v-if="filtered.length">
            <div class="scard" v-for="pr in filtered" :key="pr.title">
              <div v-if="pr.thumbnail" @click="showDetail(pr)" class="scard-img-cnt">
                <b-img-lazy :src="pr.thumbnail" blank-width="200" blank-height="200" blank-color="#212529"
                            :alt="pr.model"
                            class="scard-img-top img-fluid"/>
              </div>
              <div class="scard-body">
                <h4 class="scard-title">{{pr.model}}</h4>
                <ul class="list-unstyled" v-if="product === 'b'">
                  <li>Breite: {{pr.width}} cm</li>
                  <li>Höhe: {{pr.height}} cm</li>
                </ul>
              </div>
            </div>
          </grid>
          <div class="m-auto" v-else>
            <spinner></spinner>
          </div>
        </div>
      </div>
    </section>
    <b-modal ref="detailModalRef" hide-footer centered size="lg">
      <div class="mb-4 mgrd">
        <div v-for="pr in detailProds" :key="pr.title">
          <b-button :id="pr.model" variant="link" @click="changeDetailImage(pr)" class="btn-thumb"
                    v-bind:class="{ active: pr.model===activeModel }">
            <b-img :src="pr.t" alt="Thumbnail" fluid/>
            <h5>{{pr.model}}</h5>
          </b-button>
        </div>
      </div>
      <b-img fluid :src="detailImage"/>
    </b-modal>
  </div>
</template>

<script>
import ftNavbar from '@/components/FTNavbar'
import Grid from '@/components/Grid'
import Spinner from '@/components/Spinner'
import axios from 'axios'

export default {
  name: 'Spiegel',
  components: {ftNavbar, Grid, Spinner},
  data () {
    return {
      product: 'b',
      b: [],
      ek: [],
      ed: [],
      width: 0,
      bStyle: 0,
      bStyles: [],
      activeModel: null,
      mnumber: null,
      detailImage: null,
      detailProds: [],
      productViews: [
        {value: 'b', text: 'Begleitstäbe'},
        {value: 'ek', text: 'Eckstücke'},
        {value: 'ed', text: 'Entre-deux'}
      ],
      widths: [
        {value: 0, text: 'Alle Breiten'},
        {value: 1, text: '0cm - 5cm'},
        {value: 2, text: '5cm - 10cm'},
        {value: 3, text: 'grösser 10cm'}
      ]
    }
  },
  computed: {
    products () {
      if (this.product === 'ek') {
        return this.ek
      } else if (this.product === 'ed') {
        return this.ed
      }
      return this.b
    },

    filtered () {
      let filtered = this.b
      if (this.product === 'ek') {
        filtered = this.ek
      } else if (this.product === 'ed') {
        filtered = this.ed
      }

      if (this.mnumber) {
        return filtered.filter(m => ('' + m.model).indexOf('' + this.mnumber) === 0)
      }

      if (this.product === 'b') {
        if (this.width === 1) {
          filtered = filtered.filter(r => r.width <= 5)
        } else if (this.width === 2) {
          filtered = filtered.filter(r => r.width > 5 && r.width <= 10)
        } else if (this.width === 3) {
          filtered = filtered.filter(r => r.width > 10)
        }
        if (this.bStyle > 0) {
          filtered = filtered.filter(r => r.styles.indexOf(this.bStyle) > -1)
        }
      }
      return filtered
    }
  },

  methods: {
    showDetail (r) {
      this.activeModel = r.model
      let stab
      if (r.hasOwnProperty('b')) {
        stab = this.b.filter(b => b.model === r.b)[0]
      } else {
        stab = r
      }

      this.detailProds = [
        {t: stab.thumbnail, detail: stab.detail, model: stab.model},
        {t: stab.thumbnail_comp, detail: stab.detail_comp, model: 'Spiegel'}
      ]

      this.detailProds.push(...this.ek.filter(ek => ek.b === stab.model).map(ek => ({
        t: ek.thumbnail,
        detail: ek.detail,
        model: ek.model
      })))

      this.detailProds.push(...this.ed.filter(ed => ed.b === stab.model).map(ed => ({
        t: ed.thumbnail,
        detail: ed.detail,
        model: ed.model
      })))
      this.changeDetailImage(r)
      this.$refs.detailModalRef.show()
    },
    changeDetailImage (r) {
      if (this.detailImage !== r.detail) {
        this.activeModel = r.model
        this.detailImage = ''
        this.detailImage = r.detail
      }
    }
  },
  mounted () {
    axios.get(`${this.$api}/spiegel/list/`)
      .then(response => {
        this.b = response.data.b
        this.bStyles = response.data.bstyles
        this.ek = response.data.ek
        this.ed = response.data.ed
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style lang="scss">
  @import "../styles/variables";

  .over {
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    position: absolute;
    z-index: 1;
  }

  .mgrd {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    grid-column-gap: 1em;
    grid-row-gap: 20px;
    grid-row: 1;
  }

  .btn-thumb, .btn-thumb:focus {
    padding: 0.8em 0.8em 0.2em;
    border: 1px #ddd solid;
    color: $gray-900;
    background-color: #fff;
    text-decoration: none;

    &.active {
      background-color: #EDE7F6;
      border-color: #9575CD;

      &:hover {
        border-color: #7E57C2;
        background-color: #D1C4E9;
      }
    }

    &:hover {
      text-decoration: none;
      color: $gray-900;
      border-color: $gray-400;
      background-color: $gray-200;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Spiegel.vue